
// npm
import React from 'react'


const MessagesContext = React.createContext();


export {MessagesContext}